package com.essntl.features.task.ui.alltasks.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import com.essntl.features.task.ui.alltasks.AllTasksEvent
import com.essntl.features.task.ui.alltasks.AllTasksNavigation
import com.essntl.features.task.ui.alltasks.AllTasksState
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.secondary.EsMediumSecondaryButton
import com.essntl.uikit.components.card.TodayDateCard
import com.essntl.uikit.components.card.WeekDateCard
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.toggle.EsTab
import com.essntl.uikit.components.toggle.TabState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsRowDefaultItem
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ColumnScope.AllTasksHeader(
    state: AllTasksState,
    onEvent: (AllTasksEvent) -> Unit,
    onNavigation: (AllTasksNavigation) -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "Tasks",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.h2Bold32,
        )

        EsLargePrimaryButton(
            onClick = {
                onNavigation(AllTasksNavigation.AddTask)
            },
            text = "Add task",
            suffixIconRes = EsIcons.Add,
            modifier = Modifier
                .focusProperties { canFocus = false },
        )
    }

    Spacer(modifier = Modifier.height(1.spacing))

    if (state.getAllOverDueTasks.data
            .orEmpty()
            .isNotEmpty()
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                .background(MaterialTheme.esColorScheme.bgError)
                .padding(
                    vertical = EsConstants.SectionVerticalPadding,
                    horizontal = EsConstants.SectionHorizontalPadding,
                ),
        ) {
            Text(
                text = "${state.getAllOverDueTasks.data?.size} tasks are overdue",
                color = MaterialTheme.esColorScheme.textContrast,
                style = MaterialTheme.esTypography.p1Medium16,
            )

            EsMediumSecondaryButton(
                onClick = {
                    onNavigation(AllTasksNavigation.ShowOverdueTasks)
                },
                text = "Show tasks",
            )
        }

        Spacer(modifier = Modifier.height(1.spacing))
    }

    Row(
        verticalAlignment = Alignment.Top,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        if (state.filterOptions.weeklyTasks) {
            WeekDateCard(
                date = state.filterOptions.monday,
                datesRange = state.filterOptions.weekDatesRange,
                onDateSelected = {
                    onEvent(
                        AllTasksEvent.FilterTasks(state.filterOptions.copy(monday = it)),
                    )
                    onNavigation(AllTasksNavigation.CloseSidePanel)
                },
            )
        } else {
            TodayDateCard(
                date = state.filterOptions.dueDate,
                onDateSelected = {
                    onEvent(
                        AllTasksEvent.FilterTasks(
                            state.filterOptions.copy(
                                dueDate = it,
                            ),
                        ),
                    )
                    onNavigation(AllTasksNavigation.CloseSidePanel)
                },
            )
        }

        val tabItems = listOf(
            TabState(index = 0 ,text = "Day"),
            TabState(index = 1 ,text = "Week"),
        )

        val (selectedTabIndex, setSelectedTabIndex) = remember {
            mutableStateOf(tabItems.first().index)
        }

        EsTab(
            items = tabItems,
            selectedItemIndex = selectedTabIndex,
            onClick = { tabState ->
                onEvent(
                    AllTasksEvent.FilterTasks(
                        state.filterOptions.copy(
                            weeklyTasks = tabState.index == 1,
                        ),
                    ),
                )
                setSelectedTabIndex(tabState.index)
            },
        )

        /*
        EsMediumOutlineButton(
            onClick = {
                onEvent(
                    AllTasksEvent.GetAllTasksByDate(
                        date = state.dueDate,
                        weeklyTasks = !state.weeklyTasks,
                    ),
                )
                onNavigation(AllTasksNavigation.CloseSidePanel)
            },
            suffixIconRes = if (state.weeklyTasks)
                EsIcons.Tick else
                null,
            text = "Weekly tasks",
        )

        Spacer(modifier = Modifier.width(1.spacing))

        EsMediumOutlineButton(
            onClick = {
                onEvent(
                    AllTasksEvent.GetAllTasksByDate(
                        date = state.dueDate,
                        pastTasks = !state.pastTasks,
                    ),
                )
                onNavigation(AllTasksNavigation.CloseSidePanel)
            },
            suffixIconRes = if (state.pastTasks)
                EsIcons.Tick else
                null,
            text = "Past tasks",
        )

         */
    }

    Spacer(modifier = Modifier.height(1.spacing))

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.ListRowVerticalPadding,
                horizontal = EsConstants.ListRowHorizontalPadding + EsConstants.SectionHorizontalPadding,
            )
            .height(EsConstants.ListColumnHeaderHeight),
    ) {
        // task notes
        EsRowDefaultItem(
            text = "Title",
            isFirst = true,
            weight = 2f,
        )

        // task owner
        EsRowDefaultItem(
            text = "Owner",
        )

        // task status
        EsRowDefaultItem(
            text = "Status",
        )

        // task dueDate
        EsRowDefaultItem(
            text = "Due Date",
        )

        // task
        EsRowDefaultItem(
            text = "Traveller",
        )

        // task service
        EsRowDefaultItem(
            text = "Service",
        )
    }
}